import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import PageNotFoundImg from '@/assets/page_not_found.png'


const NotFound = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    console.error("404 Error: Non-existent route:", pathname);
  }, [pathname]);

  return (
    <div className="overflow-y-scroll bg-[#121212] flex flex-col items-center justify-center w-full h-screen gap-8">
      <div className="lg:w-1/2 p-4">
        <img
          src={PageNotFoundImg}
          alt="Not found illustration"
          className="user-drag-none select-none w-full max-h-[500px] object-contain text-blue-600 pointer-events-none"/>
      </div>
      <div className="text-center lg:w-1/2 px-4">
        
        <a
          href="/"
          className="inline-flex items-center gap-2 bg-transparent border-[1px] border-white hover:bg-[#6eb3ee] hover:text-black text-white px-4 py-2 rounded-full transition"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 
                 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 
                 1 0 010 1.414z"
            />
          </svg>
          Return Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
